module.exports = __webpack_public_path__ + "img/domestic-1984-sss-prep.cabecd84.jpg";